import { useEffect, useState } from "react";
import SectionSkeleton from "@/components/base/SectionSkeleton";
import SEO from "@/components/SEO";
import SectionRenderer from "@/components/sections/SectionRenderer";
import { getPageBySlug } from "@/api/content";
import { canonical, webPageSchema } from "@/utils/seo";
import type { Page } from "@/types/content";

export default function AboutPage({ initialData }: { initialData?: Page | null }) {
  const [page, setPage] = useState<Page | null>(initialData ?? null);
  const [loading, setLoading] = useState(!initialData);

  useEffect(() => {
    getPageBySlug("about").then((data) => {
      setPage(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <SectionSkeleton type="spinner" />;
  }

  if (!page) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <p className="text-slate-400">頁面載入失敗</p>
      </div>
    );
  }

  const baseMeta = page.seo || {
    title: `${page.title}｜美好時光指南`,
    description: "了解美好時光指南的使命與團隊，我們透過神秘客實地走訪，為你帶來最真實的店家評比。",
  };
  const meta = {
    ...baseMeta,
    canonical: baseMeta.canonical || canonical("/about"),
    keywords: baseMeta.keywords || ["關於我們", "美好時光指南", "美業探店", "神秘客", "團隊介紹"],
    structuredData: baseMeta.structuredData || webPageSchema(baseMeta.title, baseMeta.description || "了解美好時光指南的使命與團隊。", "/about"),
  };

  return (
    <>
      <SEO meta={meta} />
      <SectionRenderer sections={page.content} />
    </>
  );
}